import { JssStyle } from 'jss'
import breakpoints from './breakpoints'
import { colors } from './palette'
import { zIndexes } from './zIndex'

export const baseButton: JssStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5em 1.75em',
    margin: '0 0.3em 0.3em 0',
    borderRadius: '0.25em',
    boxSizing: 'border-box',
    textDecoration: 'none',
    fontWeight: 400,
    textAlign: 'center',
    transition: 'all 0.2s',
    boxShadow: 0,
    background: 'inherit',
    '&:hover': {
        cursor: 'pointer',
    },
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    border: 0,
}

export const sortPlaceholder = {
    display: 'flex',
    alignItems: 'center',
    padding: '0.75em 0',
    margin: '0 0.3em 0.3em 0',
    borderRadius: '6px',
    boxSizing: 'border-box',
    textDecoration: 'none',
    fontWeight: 400,
    textAlign: 'left',
    transition: 'all 0.2s',
    boxShadow: 0,
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '120%',
    color: '#000000',
    border: 0,
    background: 'none',
}

// contentWrapper: {
// 	padding: '20px',
// 	overflow: 'auto',
// 	height: '100%',
// 	paddingBottom: '160px',
// },
// formControl: {
// 	padding: '20px 0',
// },
// accordionWrapper: {
// 	marginBottom: '20px',
// },
// filterBottom: {
// 	display: 'flex',
// 	position: 'absolute',
// 	bottom: '0',
// 	width: '100%',
// 	padding: '20px',
// 	left: '0',
// 	zIndex: 4,
// 	background: colors.white,
// 	borderTop: `1px solid ${colors.borderColor}`,
// 	'& > button': {
// 			flexGrow: 1,
// 	},
// 	'& > button:last-of-type': {
// 			marginRight: '0',
// 	},
// },

export const container = {
    padding: '0 1.5rem',
    [`@media (min-width: ${breakpoints.Desktop}px)`]: {
        '&': {
            padding: '0',
        },
    },
}

export const contentWrapper = {
    padding: '20px',
    overflow: 'auto',
    height: '100%',
    paddingBottom: '160px',
}

export const formControl = {
    padding: '20px 0',
}

export const accordionWrapper = {
    marginBottom: '20px',
}

export const filterBottom = {
    display: 'flex',
    position: 'absolute',
    bottom: '0',
    width: '100%',
    padding: '20px',
    left: '0',
    zIndex: 4,
    background: colors.white,
    borderTop: `1px solid ${colors.borderColor}`,
    '& > button': {
        flexGrow: 1,
    },
    '& > button:last-of-type': {
        marginRight: '0',
    },
}

export const dialogCloseButton = {
    position: 'absolute',
    right: 0,
    top: 0,
    display: 'inline-block',
    padding: '0.75em 1.75em',
    margin: '0 0.3em 0.3em 0',
    borderRadius: '0.25em',
    boxSizing: 'border-box',
    textDecoration: 'none',
    fontWeight: 400,
    textAlign: 'center',
    transition: 'all 0.2s',
    background: 'transparent',
    boxShadow: 0,
    '&:hover': {
        cursor: 'pointer',
    },
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    border: 0,
    '&:hover svg': {
        fill: colors.gray500,
    },
}

export const headerArea = {
    display: 'flex',
    padding: '.5rem 0',
    minHeight: '5rem',
}

export const numberOfMembers = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem 0',
    minHeight: '5rem',
}

export const control = {
    display: 'grid',
    position: 'absolute',
    alignItems: 'center',
    marginBottom: '20px',
    gridTemplateColumns: '1fr 1fr',
    paddingRight: '57px',
    paddingLeft: '20px',
    borderBottom: `2px solid ${colors.borderColor}`,
    width: 'calc(100% + 40px)',
    paddingBottom: '20px',
    top: '0',
    paddingTop: '20px',
    backgroundColor: colors.white,
    zIndex: zIndexes.drawer,
}

export const tooltip = {
    textWithIcon: {
        width: '1rem',
        height: '1rem',
        border: `1px solid ${colors.red600}`,
        borderRadius: '50%',
        marginLeft: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        width: '1rem',
        height: '1rem',
        borderRadius: '50%',
    },
}

export const card = {
    position: 'relative',
    backgroundColor: colors.white,
    width: '100%',
    color: 'black',
    marginBottom: '10px',
    borderRadius: '4px',
    border: `1px solid ${colors.borderColor}`,
    padding: '1rem',
    transition: 'all 0.5s linear',
}

export const cardTitle = {
    title: {
        display: '-webkit-box',
        WebkitLineClamp: '1',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}

export const cardProps = {
    card: {
        ...card,
    },
    title: {
        ...cardTitle,
    },
}
